export default "__VITE_ASSET__CkPMVjHs__"